import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import { ConfigProvider } from './contexts/ConfigContext';
import { PersistGate } from 'redux-persist/integration/react';

import './index.scss';
// Initialize i18n before mounting the app
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store, persister } from './store';
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

// Suspense is required by react-i18next when useSuspense:true
// The fallback renders while translation JSON files are being fetched
const I18nFallback = () => (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <span>Chargement...</span>
    </div>
);

ReactDOM.render(
    <Provider store={store}>
        <ConfigProvider>
            <PersistGate loading={null} persistor={persister}>
                <Suspense fallback={<I18nFallback />}>
                    <App />
                </Suspense>
            </PersistGate>
        </ConfigProvider>
    </Provider>,
    document.getElementById('root')
);

serviceWorkerRegistration.register();

reportWebVitals();
